import { useState } from "react";
import { Outlet } from "react-router-dom";

import MobileMenuButton from "./MobileMenuButton";
import DashboardSidebar from "./DashboardSidebar";
import { GlobalSearch } from "../../components/global-search";

// Top-level dashboard shell. The MUI Drawer/AppBar pattern is gone —
// the persistent sidebar lives inside DashboardSidebar and the
// floating hamburger lives inside MobileMenuButton. Everything else
// is plain Tailwind.

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);

  return (
    <div className="flex h-dvh overflow-hidden">
      <MobileMenuButton onOpenSidebar={() => setOpen(true)} />
      <DashboardSidebar
        isOpenSidebar={open}
        onCloseSidebar={() => setOpen(false)}
      />
      {/* Full-height column: the search header stays put while only the content
          area below it scrolls. pl-16 clears the mobile hamburger. */}
      <main className="flex min-w-0 flex-1 flex-col overflow-hidden">
        {/* pl-16 on mobile clears the fixed hamburger (left-4 + size-10 = 56px). */}
        <header className="flex shrink-0 items-center border-b border-border/60 bg-background px-4 py-3 pl-16 lg:px-8 lg:pl-8">
          <GlobalSearch />
        </header>
        <div id="dashboard-scroll" className="flex-1 overflow-auto px-4 pt-6 pb-10 lg:px-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
